<template>
  <div style="height: 100%">
    <div style="width: 200px; position: absolute; z-index: 20">
      <Float_menu />
    </div>
    <div style="height: 100%; display: flex; align-items: center">
      <div
        ref="DC_GR_1F"
        :style="{
          width: '100%',
          height: '920px',
          backgroundImage: 'url(' + this.backgroud_png + ') ',
          backgroundRepeat: 'no-repeat',
          marginLeft: '200px',
        }"
      ></div>
    </div>
  </div>
</template>

  <script>
import * as echarts from "echarts";
// import { getTopoData } from "../utils/topo_utils";
import { Url, grafana_Url, tooltip_basecss } from "../config/env";
import Float_menu from "../views/Float_menu";

export default {
  data() {
    return {
      baseUrl: Url,
      backgroud_png: Url + "/topo_data/DC_GR_1F/dc_gr_1f_bg.png",
      mychartOptions: {},
      chartWidth: 1720,
      chartHeight: 920,

      envData: {
        colors: {
          status_colors: ["#4301E6", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
        },
      },
    };
  },
  components: { Float_menu },
  methods: {
    getTopoData: async function (topo_name, env_Data) {
      let options = {};
      //获取全局变量
      const status_colors = env_Data.colors.status_colors;
      var border_colors = env_Data.colors.border_colors;
      // 获取图中主机数据
      const hosts_file = Url + "topo_data/" + topo_name + "/hosts_obj.json";
      const [hosts_data] = await Promise.all([fetch(hosts_file)]);
      const hostsData = await hosts_data.json();
      const hosts = hostsData["data"];
      let charts = {
        hosts: [],
      };
      //  生成节点数据
      for (let key in hosts) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        // let problem_info = "系统正常"
        //默认展示的是绑定的ITEM信息,除非inventoryShow为1
        //默认加入绑定的ITEM信息，判断inventoryShow，满足条件则用inventory信息替代

        let tooltip_list =
          hosts[key]["inventoryShow"] == "0"
            ? hosts[key]["item_info"]
            : // : Object.keys(hosts[key]["inventory"]).length > 0
            hosts[key]["inventory"].length > 0
            ? hosts[key]["inventory"]
            : hosts[key]["item_info"];
        let problem_obj = hosts[key]["problems"];

        if (Object.keys(tooltip_list).length != 0) {
          tooltip_info = "";
          for (let item of tooltip_list) {
            tooltip_info +=
              '<div><span style="color:gray">' +
              Object.keys(item) +
              "&nbsp" +
              '</span>:<span style="color:green">' +
              "&nbsp" +
              Object.values(item) +
              "</></div>";
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' +
                n +
                "." +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:green">系统正常</div>';
        }
        let node = {
          // x:hosts[key]['coords'][0],
          // y:hosts[key]['coords'][1],
          name: hosts[key]["nodeName"],
          value: hosts[key]["coords"],
          zlevel: parseInt(hosts[key]["zlevel"]),
          // symbolSize: this.envData.nodeSymbolsize[hosts[key]["pngPath"]],
          // symbolSize: hosts[key]["symbolSize"].split(","),
          symbolSize: [
            hosts[key]["symbolSize"].split(",")[0],
            hosts[key]["symbolSize"].split(",")[1],
          ],
          nodeStatus: hosts[key]["nodeStatus"],
          symbol:
            "image://" +
            Url +
            "/topo_data/" +
            topo_name +
            "/" +
            hosts[key]["pngPath"] +
            //去掉了标识状态
            "_" +
            hosts[key]["nodeStatus"] +
            ".png",
          itemStyle: {
            // borderWidth: 5,
          },
          // label: {
          //     show: hosts[key]["labelShow"] == true,
          //     position: "bottom",
          //     color: "#4301E6",
          //     fontFamily: "Arial",
          //     fontSize: 15,
          //     formatter: hosts[key]["nodeName"]
          // },
          tooltip: tooltip_info,
          url1:
            hosts[key]["url1"][0] == "#"
              ? Url + hosts[key]["url1"]
              : grafana_Url[hosts[key]["url1"]] +
                "&var-HOST=" +
                hosts[key]["zabbix_hostname"],
          url2:
            hosts[key]["url2"][0] == "#"
              ? Url + hosts[key]["url2"]
              : hosts[key]["url2"],
        };
        charts.hosts.push(node);
      }
      //节点按照给定的zlevel排序，最低为5
      charts.hosts = charts.hosts.sort((a, b) => a.zlevel - b.zlevel);
      return charts;
    },
    makeChartOption(chartData) {
      let options = {
        // backgroundColor: "#111217",
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          width: 1720,
          height: 920,
        },
        xAxis: {
          min: 0,
          max: this.chartWidth,
          show: false,
          type: "value",
        },
        yAxis: {
          min: 0,
          max: this.chartHeight,
          show: false,
          inverse: true,
          type: "value",
        },
        tooltip: tooltip_basecss,
        series: [
          ///节点数据
          {
            type: "graph",
            coordinateSystem: "cartesian2d",
            roam: true,
            layout: "none",
            emphasis: {
              // disabled: true,
              scale: 1.0,
              // focus: 'self',
              // blurScope: 'global'
            },
            label: {
              show: false,
              position: "inside",
              color: "#1f0",
              fontFamily: "serif",
              fontWeight: "bold",
              fontSize: 20,
              formatter: function (item) {
                return item.data.name;
              },
            },
            data: chartData.hosts,
            itemStyle: {
              borderColor: "red",
              borderWidth: 4,
              borderType: "solid",
            },
            zoom: 2,
            zlevel: 5,
          }, //连接线条数据
        ],
      };
      return options;
    },
    maketopo: async function (topo_name) {
      let myChart = echarts.init(this.$refs[topo_name]);
      //获取数据
      let myChartData = await this.getTopoData(topo_name, this.envData);
      //定义options
      this.mychartOptions = this.makeChartOption(myChartData);
      //渲染页面
      // console.log(this.mychartOptions);
      myChart.setOption(this.mychartOptions);

      //故障节点动画效果
      setInterval(() => {
        for (let i in this.mychartOptions.series[0].data) {
          if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
            this.mychartOptions.series[0].data[i]["symbolSize"][0] *= 1.2;
            this.mychartOptions.series[0].data[i]["symbolSize"][1] *= 1.2;
            // console.log(this.mychartOptions.series[0].data[i]);
            myChart.setOption(this.mychartOptions);
          }
        }
        setTimeout(() => {
          for (let i in this.mychartOptions.series[0].data) {
            if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
              this.mychartOptions.series[0].data[i]["symbolSize"][0] /= 1.2;
              this.mychartOptions.series[0].data[i]["symbolSize"][1] /= 1.2;
              myChart.setOption(this.mychartOptions);
            }
          }
        }, 1000);
      }, 2000);
      let click_type = null; // 定义一个定时器
      myChart.on("click", (data) => {
        if (!click_type) {
          click_type = setTimeout(() => {
            window.location.assign(data.data.url1);
            click_type = null; // 清除定时器
          }, 300);
        } else {
          window.open(data.data.url2);
          clearTimeout(click_type); // 清除定时器
          click_type = null;
        }
      });
      setInterval(async () => {
        myChart.setOption(
          this.makeChartOption(await this.getTopoData(topo_name, this.envData))
        );
      }, 60000);
      window.onresize = function () {
        myChart.resize();
        // this.chartWidth = myChart.getDom().clientWidth;
        // this.chartHeight = myChart.getDom().clientHeight;
      };
    },
  },
  mounted() {
    this.maketopo("DC_GR_1F");
  },
};
</script>
  <style lang="less" scoped>
@import "../style/mixin";
</style
.container {
  // position: relative;
  display: flex;
  justify-content: center;
  align-items: center;}
>
  
